module.exports = __webpack_public_path__ + "static/bulle_monde-c2c4458adc15fc38177e68ad9b801cfc.svg";